export default __webpack_public_path__ + "static/media/Ojo-2.b6e983a9.png";